import { vpnManagerUrlEnvVar } from "@src/cloud-connect/feature-toggles/feature-toggles";
import { buildAxiosAuthenticationHeaders } from "../util/build-axios-authentication-headers";
import axios, { isAxiosError } from "axios";

export interface VPNSupportSessionListFilters {
  machine_id?: string;
  gateway_id?: string;
  technician_user_id?: string;
  operator_user_id?: string;
  statuses?: string;
  active?: string | boolean;
}

export const getVPNSupportSessions = async (
  namespace: string,
  otherParams?: VPNSupportSessionListFilters,
) => {
  const url = vpnManagerUrlEnvVar();
  const headers = buildAxiosAuthenticationHeaders();

  try {
    const response = await axios.get(
      `${url}/api/v2/ns/${namespace}/support-sessions`,
      {
        headers: headers,
        params: {
          active: true,
          ...otherParams,
        },
      },
    );
    return response.data;
  } catch (err) {
    if (isAxiosError(err)) {
      console.error("Axios error:", err);
      throw err;
    } else {
      throw new Error(
        "An unexpected error occurred while fetching support sessions.",
      );
    }
  }
};
